import {Component, Input, ViewEncapsulation} from "@angular/core";
import {ItemCounterComponent} from "@spartacus/storefront";
import {EbAnalyticsService} from "src/app/features/analytics/services/facades/eb-analytics.service";

@Component({
    selector: 'eb-item-counter',
    templateUrl: './eb-item-counter.component.html',
    styleUrls: ['./eb-item-counter.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class EbItemCounterComponent extends ItemCounterComponent {

  @Input() productPrice?: string;
  @Input() cartPopUp?: boolean;
  @Input() pushMatomoEvents?: boolean;

  constructor(protected ebAnalyticsService: EbAnalyticsService) {
    super()
  }

  increment() {
    super.increment();
    if(this.pushMatomoEvents){
      const eventName = this.cartPopUp ? 'Quantity increase in Cart pop up': 'Quantity increase in Cart';
      this.ebAnalyticsService.pushIncrementProductEvent(this.productPrice, eventName);
    }
  }

  decrement() {
    super.decrement();
    if(this.pushMatomoEvents){
      const eventName = this.cartPopUp ? 'Quantity decrease in Cart pop up': 'Quantity decrease in Cart';
      this.ebAnalyticsService.pushDecrementProductEvent(this.productPrice,eventName);
    }
  }
}
